module.exports = __webpack_public_path__ + "static/companhia-lezirias-3ed2e60bd4e34e99b6694065dc4b40ac.png";